import { ChangeEvent } from 'react';
import { RoutingValuesCardI } from '..';
import info from '../../../../../../assets/images/icons/info.svg';
import FilterRadioButton from '../../../../../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../../../../components/FilterRadioButtonsContainer';
import FormGroup from '../../../../../../components/FormGroup';
import Input from '../../../../../../components/Input';
import OpacityAnimation from '../../../../../../components/OpacityAnimation';
import { ConditionalInputGroup, Container, Group } from '../../../styles';

export default function RoutingValuesCard({
  compareWithDesiredVtValue,
  desiredVtValue,
  chooseDefaultValueForRoutings,
  defaultValueForRoutings,
  kindOfVtSpTrans,
  setKindOfVtSpTrans,
  handleCompareWithDesiredVtValueChange,
  handleDesiredVtValueChange,
  handleChooseDefaultValueForRoutingsChange,
  handleDefaultValueForRoutingsChange,
  getErrorMessageByFieldName,
  kindOfVtAesa,
  setKindOfVtAesa,
  aboveDesiredValueReturnsBiasTag,
  setAboveDesiredValueReturnsBiasTag,
  usaRodoviarioValZero,
  setUsaRodoviarioValZero,
  kmRodoviarioValZero,
  setKmRodoviarioValZero,
  utilizaTetoValorPadraoEmp,
  setUtilizaTetoValorPadraoEmp,
}: RoutingValuesCardI) {
  return (
    <Container>
      <div className="card-title">
        Valores
      </div>
      <Group>
        <div className="title">
          <div>
            Comparar com um valor máximo de VT ideal?
            {' '}
            <img src={info} alt="info" title="Irá fazer uma comparação do valor total da roteirização com o valor informado, caso o valor roteirizado seja maior que o valor definido aqui, considerará a consulta com status de Roteirizado Acima do Teto" />
          </div>
        </div>
        <ConditionalInputGroup>
          <FilterRadioButtonsContainer notOverflow>
            <FilterRadioButton selected={compareWithDesiredVtValue} onClick={() => handleCompareWithDesiredVtValueChange(true)}>
                  Sim
            </FilterRadioButton>
            <FilterRadioButton selected={!compareWithDesiredVtValue} onClick={() => handleCompareWithDesiredVtValueChange(false)}>
                  Não
            </FilterRadioButton>
          </FilterRadioButtonsContainer>

          {compareWithDesiredVtValue && (
            <OpacityAnimation>
              <FormGroup error={getErrorMessageByFieldName('desiredVtValue')}>
                <Input
                  value={desiredVtValue}
                  onChange={handleDesiredVtValueChange}
                  error={getErrorMessageByFieldName('desiredVtValue')}
                  placeholder="R$ XX,XX"
                  maxLength={8}
                />
              </FormGroup>
            </OpacityAnimation>
          )}

        </ConditionalInputGroup>
      </Group>

      {compareWithDesiredVtValue && (
        <Group>
          <div className="title">
            <div>
              Utiliza o valor teto padrão da empresa ou o valor do local de trabalho?
              {' '}
              <img src={info} alt="info" title="Define se o teto usado nas roteirizações será o valor padrão configurado na empresa ou o valor indicado em cada local de trabalho." />
            </div>
          </div>
          <FilterRadioButtonsContainer>
            <FilterRadioButton selected={utilizaTetoValorPadraoEmp} onClick={() => setUtilizaTetoValorPadraoEmp(true)}>
              Valor padrão da empresa
            </FilterRadioButton>
            <FilterRadioButton selected={!utilizaTetoValorPadraoEmp} onClick={() => setUtilizaTetoValorPadraoEmp(false)}>
              Valor do local de trabalho
            </FilterRadioButton>
          </FilterRadioButtonsContainer>
        </Group>
      )}

      {compareWithDesiredVtValue && (
        <Group>
          <div className="title">
            <div>
              Resultados acima do teto devem retornar bilhetes de acordo com o padrão configurado?
              {' '}
              <img src={info} alt="info" title="De acordo com a cidade de origem e de destino de uma roteirização, possuímos um padrão de bilhetes que costumam ser apontados levando em consideração o menor custo. caso o valor roteirizado seja maior que o valor definido aqui, e essa opção estiver marcada, ao invés de retornar a roteirização como transporte mantido, será retornada essa combinação de bilhetes padrão." />
            </div>
          </div>
          <FilterRadioButtonsContainer>
            <FilterRadioButton selected={aboveDesiredValueReturnsBiasTag} onClick={() => setAboveDesiredValueReturnsBiasTag(true)}>
                    Sim
            </FilterRadioButton>
            <FilterRadioButton selected={!aboveDesiredValueReturnsBiasTag} onClick={() => setAboveDesiredValueReturnsBiasTag(false)}>
                    Não
            </FilterRadioButton>
          </FilterRadioButtonsContainer>
        </Group>
      )}

      <Group>
        <div className="title">
          <div>
            Indicar um valor inicial para a roteirização?
            {' '}
            <img src={info} alt="info" title="Indicará o valor inicial das roteirizações, geralmente definido como um ticket médio de quanto, atualmente, cada colaborador gasta de VT, para ser realizado um cálculo médio de economia, e saber se o valor foi ou não otimizado." />
          </div>
        </div>
        <ConditionalInputGroup>
          <FilterRadioButtonsContainer notOverflow>
            <FilterRadioButton selected={chooseDefaultValueForRoutings} onClick={() => handleChooseDefaultValueForRoutingsChange(true)}>
                  Sim
            </FilterRadioButton>
            <FilterRadioButton selected={!chooseDefaultValueForRoutings} onClick={() => handleChooseDefaultValueForRoutingsChange(false)}>
                  Não
            </FilterRadioButton>
          </FilterRadioButtonsContainer>

          {chooseDefaultValueForRoutings && (
            <OpacityAnimation>
              <FormGroup error={getErrorMessageByFieldName('defaultValueForRoutings')}>
                <Input
                  value={defaultValueForRoutings}
                  onChange={handleDefaultValueForRoutingsChange}
                  error={getErrorMessageByFieldName('defaultValueForRoutings')}
                  placeholder="R$ XX,XX"
                  maxLength={8}
                />
              </FormGroup>
            </OpacityAnimation>
          )}

        </ConditionalInputGroup>
      </Group>

      <Group>
        <div className="title">
          <div>
            Utiliza rodoviário valor zero?
            {' '}
            <img src={info} alt="info" title="Quando ativado, linhas rodoviárias que atingirem acima da quilometragem especificada terão seu valor zerado nas roteirizações." />
          </div>
        </div>
        <FilterRadioButtonsContainer>
          <FilterRadioButton selected={usaRodoviarioValZero} onClick={() => setUsaRodoviarioValZero(true)}>
            Sim
          </FilterRadioButton>
          <FilterRadioButton selected={!usaRodoviarioValZero} onClick={() => setUsaRodoviarioValZero(false)}>
            Não
          </FilterRadioButton>
        </FilterRadioButtonsContainer>
        <span style={{ fontSize: '12px', color: '#666', marginTop: '4px', display: 'block' }}>
          Indica se a empresa utiliza troca de bilhetes em linhas de transporte rodoviário. Quando uma linha rodoviária atinge acima da quilometragem especificada, seu valor é zerado nas roteirizações.
        </span>
      </Group>

      {usaRodoviarioValZero && (
        <OpacityAnimation>
          <Group>
            <div className="title">
              <div>
                Quilometragem limite (km)
                {' '}
                <img src={info} alt="info" title="Informe a quilometragem até a qual as linhas rodoviárias terão seu valor zerado nas roteirizações." />
              </div>
            </div>
            <FormGroup error={getErrorMessageByFieldName('kmRodoviarioValZero')}>
              <Input
                type="number"
                value={kmRodoviarioValZero}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setKmRodoviarioValZero(e.target.value === '' ? '' : parseInt(e.target.value, 10))}
                placeholder="Informe a quilometragem"
                error={getErrorMessageByFieldName('kmRodoviarioValZero')}
                min={1}
              />
            </FormGroup>
          </Group>
        </OpacityAnimation>
      )}

      <Group>
        <div className="title">
          <div>
            Para a SPTRANS, realiza a recarga como Vale Comum, ou VT?
            {' '}
            <img src={info} alt="info" title="O VT possui um valor ligeiramente mais alto que o vale comum, por isso algumas empresas optam por realizar a recarga como vale comum, ou reembolsar o colaborador em dinheiro." />
          </div>
        </div>
        <FilterRadioButtonsContainer>
          <FilterRadioButton selected={kindOfVtSpTrans === 'vt'} onClick={() => setKindOfVtSpTrans('vt')}>
                  VT
          </FilterRadioButton>
          <FilterRadioButton selected={kindOfVtSpTrans === 'common'} onClick={() => setKindOfVtSpTrans('common')}>
                  Comum
          </FilterRadioButton>
        </FilterRadioButtonsContainer>
      </Group>

      <Group>
        <div className="title">
          <div>
            Para a AESA, realiza a recarga como Vale Comum, ou VT?
            {' '}
            <img src={info} alt="info" title="O VT possui um valor ligeiramente mais alto que o vale comum, por isso algumas empresas optam por realizar a recarga como vale comum, ou reembolsar o colaborador em dinheiro." />
          </div>
        </div>
        <FilterRadioButtonsContainer>
          <FilterRadioButton selected={kindOfVtAesa === 'vt'} onClick={() => setKindOfVtAesa('vt')}>
                  VT
          </FilterRadioButton>
          <FilterRadioButton selected={kindOfVtAesa === 'common'} onClick={() => setKindOfVtAesa('common')}>
                  Comum
          </FilterRadioButton>
        </FilterRadioButtonsContainer>
      </Group>
    </Container>
  );
}
